import { useLocation } from 'react-router-dom';
import { getLocaleFromPath, localizePath, Locale } from '../config/seoPages';

export function useLocale(): Locale {
  const { pathname } = useLocation();
  return getLocaleFromPath(pathname);
}

export function useLocalizedPath() {
  const locale = useLocale();
  return (path: string) => localizePath(path, locale);
}
